import { useMemo } from 'react';

import { useMe } from './useMe';

export enum AccountDeletionRequestStatus {
	accepted = 'accepted',
	pending = 'pending',
	refused = 'refused'
}

export type AccountDeletionRequestStatusType = keyof typeof AccountDeletionRequestStatus | null;

export const useAccountManagement = () => {
	const { isMeLoading, me } = useMe();

	const accountDeletionRequestStatus = me?.accountDeletionRequestStatus as AccountDeletionRequestStatus;

	const isDeletionOngoing = useMemo(
		() =>
			accountDeletionRequestStatus !== null &&
			accountDeletionRequestStatus !== AccountDeletionRequestStatus.refused,
		[me]
	);

	return { isDeletionOngoing, isLoading: isMeLoading };
};
